import React from "react";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Header from "../components/Header/userHeader";
import { UserFooter } from "../components";
const sections = [
  {
    title: "1. Nature of Relationship and Categorization",
    subsections: [
      [
        "1.1. Principal-to-Principal",
        "This Agreement operates on a principal-to-principal basis.",
      ],
      [
        "1.2. Partner Categories",
        "Upon onboarding, the Partner shall be registered under one or more of the following operational categories:",
      ],
    ],
    categoryCards: [
      [
        "A.",
        "Category A: Sthanick-Fulfilled Merchant",
        "Physical goods delivered by Sthanick's network.",
      ],
      [
        "B.",
        "Category B: Self-Delivery Merchant",
        "Physical goods delivered by the Merchant's own personnel.",
      ],
      [
        "C.",
        "Category C: Hyperlocal Service Provider",
        "Professional/home services negotiated and fulfilled off-platform.",
      ],
    ],
  },
  {
    title: "2. Obligations for Merchants (Categories A & B: Physical Goods)",
    subsections: [
      [
        "2.1. Catalog and Inventory",
        "The Merchant shall provide an accurate, real-time catalog of goods, including prices, descriptions, and images.",
      ],
      [
        "2.2. Quality and Compliance",
        "The Merchant guarantees that all goods meet industry safety standards, are within expiry dates, and comply with all applicable laws (including FSSAI).",
      ],
      [
        "2.3. Packaging",
        "The Merchant is strictly responsible for packaging goods securely to ensure they survive transit without damage or contamination.",
      ],
      [
        "2.4. Price Parity",
        "The Merchant agrees that the prices listed on Sthanick shall not exceed the prices charged for identical items at their physical storefront.",
      ],
    ],
  },
  {
    title: "3. Logistics and Fulfillment Rules",
    subsections: [
      [
        "3.1. For Category A (Sthanick-Fulfilled)",
        "The Merchant must have the order packed and ready for handover by the time the Sthanick-assigned Delivery Partner arrives.",
      ],
      [
        "3.2. For Category B (Self-Delivery)",
        "By choosing this model, the Merchant assumes absolute responsibility for the timely, safe, and hygienic transport of the goods to the User. The Merchant agrees to adhere strictly to the Estimated Times of Arrival (ETAs). The Company bears zero liability for any loss, damage, theft, or disputes arising during transit under Self-Delivery.",
      ],
    ],
  },
  {
    title:
      "4. Obligations for Service Providers (Category C: Hyperlocal Services)",
    subsections: [
      [
        "4.1 Platform as Directory",
        "Sthanick acts exclusively as a lead-generation and discovery directory.",
      ],
      [
        "4.2 Off-Platform Fulfillment",
        "All negotiations, finalized quotes, and actual service delivery occur entirely off-platform, directly with the User.",
      ],
      [
        "4.3. Liability Waiver & COD",
        "The Company does not guarantee the work and bears zero liability for incomplete work, property damage, or pricing disputes. The Company does not collect funds for these transactions.",
      ],
    ],
  },
  {
    title: "5. Commercial Terms and Financial Settlements",
    subsections: [
      [
        "5.1. Commission & Lead Fees",
        "The Partner agrees to pay the Company agreed-upon platform commissions (for Categories A & B) or flat lead-generation fees (for Category C).",
      ],
      [
        "5.2. Payment Collection",
        "For Categories A & B, the Partner authorizes the Company via Razorpay to collect payments from Users.",
      ],
      [
        "5.3. Settlement Cycle",
        "Remittances are processed to the Partner's bank account on a standard cycle (e.g., Weekly), minus commissions, taxes (TCS/TDS), and fault-based User refunds.",
      ],
    ],
  },
  {
    title: "6. Vendor Data Privacy",
    blocks: [
      "The Partner agrees to use User data (including names, addresses, and phone numbers) provided by Sthanick strictly for the purpose of fulfilling the specific order or service request. The Partner shall not store, misuse, sell, or use this data for independent marketing purposes.",
    ],
  },
  {
    title: "7. Indemnity & Governing Law",
    blocks: [
      "The Partner agrees to indemnify, defend, and hold harmless Arthavyavas Private Limited from any claims, damages, or lawsuits arising out of the consumption of their products, actions of their staff, or breach of statutory laws.",
      "Disputes shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.",
    ],
  },
];

const Vendoragreement = () => {
  return (
    <Box
      sx={{
        bgcolor: "#fbf5ec",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Header />
      <Box
        component="section"
        sx={{
          bgcolor: "#ff6b0b",
          color: "#fff",
          textAlign: "center",
          pt: { xs: 7, md: 6.4 },
          pb: { xs: 7, md: 7.9 },
        }}
      >
        <Container maxWidth="md">
          <Typography
            component="h1"
            sx={{
              maxWidth: 760,
              mx: "auto",
              fontSize: { xs: 36, md: 49 },
              lineHeight: 1.02,
              fontWeight: 900,
              letterSpacing: 0,
              mb: 2.3,
            }}
          >
            Vendor Onboarding & Service Agreement
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 17, md: 19 },
              lineHeight: 1.45,
              letterSpacing: 0.4,
              color: "rgba(255,255,255,0.92)",
            }}
          >
            This agreement constitutes a legally binding contract for all our
            Partners.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth={false} sx={{ maxWidth: 880, px: { xs: 2, md: 3 } }}>
        <Paper
          elevation={0}
          sx={{
            mt: 5,
            mb: 5,
            borderRadius: "12px 12px 10px 10px",
            borderTop: "2px solid #f05a1a",
            bgcolor: "#fff",
            boxShadow: "0 16px 38px rgba(51, 36, 22, 0.12)",
            px: { xs: 3, sm: 4, md: 5 },
            py: { xs: 4, md: 4.8 },
          }}
        >
          <Typography sx={{ ...paragraphSx, mb: 4.8 }}>
            This Vendor Onboarding and Service Agreement ("Agreement")
            constitutes a legally binding contract entered into by and between{" "}
            <Box component="strong" sx={{ color: "#243145", fontWeight: 900 }}>
              Arthavyavas Private Limited
            </Box>{" "}
            ("Company" / "Sthanick") and the Vendor/Service Provider
            ("Partner").
          </Typography>

          {sections.map((section) => (
            <AgreementSection key={section.title} section={section} />
          ))}
        </Paper>
      </Container>

      {/* <Box
        component="footer"
        sx={{
          bgcolor: "#070c15",
          color: "#fff",
          textAlign: "center",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          py: 3.4,
        }}
      >
        <Stack alignItems="center" spacing={1.4}>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.8}>
            <LocationOnOutlinedIcon sx={{ color: "#ff6b1a", fontSize: 24 }} />
            <Typography sx={{ fontSize: 23, fontWeight: 900 }}>Sthanick</Typography>
          </Stack>
          <Typography sx={{ color: "#8791a4", fontSize: 14 }}>
            An initiative by Arthavyavas Private Limited
          </Typography>
          <Typography sx={{ color: "#626d81", fontSize: 13 }}>
            {"\u00a9 2026 Sthanick. All rights reserved."}
          </Typography>
        </Stack>
      </Box> */}
      <UserFooter />
    </Box>
  );
};

const paragraphSx = {
  color: "#314054",
  fontSize: { xs: 16, md: 17 },
  lineHeight: 1.58,
  letterSpacing: 0.45,
  mb: 1.9,
};

const headingSx = {
  color: "#f05a1a",
  fontSize: { xs: 22, md: 25 },
  fontWeight: 900,
  letterSpacing: 0.5,
  borderBottom: "1px solid #f0dfcf",
  pb: 1,
  mb: 2.3,
};

const subheadingSx = {
  color: "#071326",
  fontSize: { xs: 16, md: 18 },
  lineHeight: 1.25,
  fontWeight: 900,
  letterSpacing: 0.15,
  mb: 0.7,
};

const AgreementSection = ({ section }) => (
  <Box component="section" sx={{ mb: { xs: 4.1, md: 4.7 } }}>
    <Typography component="h2" sx={headingSx}>
      {section.title}
    </Typography>

    {section.blocks?.map((text) => (
      <Typography key={text} sx={paragraphSx}>
        {text}
      </Typography>
    ))}

    {section.subsections?.map(([title, text]) => (
      <Box key={title} sx={{ mb: 2.2 }}>
        <Typography component="h3" sx={subheadingSx}>
          {title}
        </Typography>
        <Typography sx={paragraphSx}>{text}</Typography>
      </Box>
    ))}

    {section.categoryCards && (
      <Stack spacing={1.5} sx={{ mt: 0.7 }}>
        {section.categoryCards.map(([letter, label, text]) => (
          <Paper
            key={letter}
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1.6,
              border: "1px solid #f5ddc0",
              bgcolor: "#fff8ef",
              borderRadius: 1,
              px: { xs: 1.8, md: 2.2 },
              py: { xs: 1.7, md: 1.9 },
            }}
          >
            <Typography
              sx={{
                color: "#f05a1a",
                fontSize: 17,
                fontWeight: 900,
                lineHeight: 1.45,
                minWidth: 24,
              }}
            >
              {letter}
            </Typography>
            <Typography sx={{ ...paragraphSx, mb: 0 }}>
              <Box
                component="strong"
                sx={{ color: "#243145", fontWeight: 900 }}
              >
                {label}
              </Box>{" "}
              ({text})
            </Typography>
          </Paper>
        ))}
      </Stack>
    )}
  </Box>
);

export default Vendoragreement;
